import styled from "styled-components";


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 30px 30px 20px;
  width: 100%;
  min-width: 0;
  height:100%;
  gap:20px;
  box-sizing: border-box;
  /* position: relative; */

  @media (max-width: 768px) {
    padding: 10px 16px 30px;
  }
`
